import session from './session'
import usage from './usage'
import aggregate from './aggregate'
import user from './user'
import invoice from './invoice'
import account from './account'
import userSetting from './user_setting'
import exchangeRate from './exchange_rate'
import manage from './manage'
import download from './download'
import promotionCredit from './promotion_credit'
import alarm from './alarm'
import consolidated from './consolidated'
import userIp from './user_ip'

export default {
  session,
  usage,
  aggregate,
  user,
  invoice,
  account,
  userSetting,
  exchangeRate,
  manage,
  download,
  promotionCredit,
  alarm,
  consolidated,
  userIp,
}
